import { createFileRoute } from "@tanstack/react-router";
import { PortalAlertsV2Page } from "@/components/v2/pages/portal-alerts-v2-page";

export const Route = createFileRoute("/portal/alerts")({
  component: PortalAlertsV2Page,
});
